export const Gift_Submit_Details = "GIFTFORMSUBMIT";